import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import "../styles/burgermenu.css";
import logo from "../assets/logo.png";

const BurgerMenu = () => {
    const [isOpen, setIsOpen] = useState(false);
    const menuRef = useRef(null);

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    // Close menu if clicked outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        if (isOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }

        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [isOpen]);

    return (
        <div className="burger-menu" ref={menuRef}>
            {/* Burger Icon */}
            <div className={`burger-icon ${isOpen ? "open" : ""}`} onClick={toggleMenu}>
                <span></span>
                <span></span>
                <span></span>
            </div>

            {/* Menu Items */}
            <div className={`menu-items ${isOpen ? "open" : ""}`}>
                <img src={logo} alt="Better Sleeping Logo" className="logo-menu" />
                <Link to="/" onClick={toggleMenu}>Home</Link>
                <Link to="/categories" onClick={toggleMenu}>Categories</Link>
                <Link to="/contact" onClick={toggleMenu}>Contact Us</Link>
            </div>
        </div>
    );
};

export default BurgerMenu;
